
<template>
    <div class="pembelian__filters-container">

        <!-- all -->
        <div class="px-6 pt-6">
          <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': pembelianFilter == 'all'}" :to="`${baseUrl}/filter/all`">
              <feather-icon icon="LayersIcon" :svgClasses="[{'text-primary stroke-current': pembelianFilter == 'all'}, 'h-6 w-6']"></feather-icon>
              <span class="text-lg ml-3">All</span>
          </router-link>
        </div>

        <vs-divider></vs-divider>

        <!-- starred -->
        <div class="px-6 py-4">
            <div class="flex items-center flex-wrap justify-between">
                <div class="flex items-center">
                  <h5>Kategori</h5>
                </div>
                <div class="flex">
                    <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="kategoriAddOpen" />
                </div>
            </div>
            <template v-for="kategori in pembelianKategoris">
                <router-link tag="span" class="flex mt-6 cursor-pointer" :to="`${baseUrl}/kategori-pembelian/${kategori.slug}`" :key="kategori.slug">
                    <span class="text-lg" :class="{'text-primary': pembelianFilter == kategori.slug}">{{ kategori.name }}</span>
                </router-link>
            </template>
        </div>

        <vs-divider></vs-divider>

        <div class="px-6 py-4">
            <div class="flex items-center flex-wrap justify-between">
                <div class="flex items-center">
                  <h5>Supplier</h5>
                </div>
                <div class="flex">
                    <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="supplierAddOpen" />
                </div>
            </div>
            <div class="pembelian__lables-list">
              <div class="flex items-center flex-wrap justify-between mt-4" v-for="(supplier, index) in suppliers" :key="index">
                <router-link tag="span" class="pembelian__label flex items-center cursor-pointer" :to="`${baseUrl}/kontak/${supplier.slug}`">
                  <span class="text-lg" :class="{'text-primary': pembelianFilter == supplier.slug}">{{ supplier.name }}</span>
                </router-link>
                <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-edit-2" size="small" @click="supplierEditOpen(supplier)"></vs-button>
              </div>
            </div>
        </div>

        <vs-divider></vs-divider>

        <div class="px-6 py-4">
          <div class="flex items-center flex-wrap justify-between">
              <div class="flex items-center">
                <h5>Status Lunas</h5>
              </div>
          </div>
          <div class="pembelian__lables-list">
              <router-link tag="span" class="pembelian__label flex items-center mt-6 cursor-pointer" :to="`${baseUrl}/status-lunas/lunas-belum`">
                  <div class="h-3 w-3 rounded-full mr-2 bg-danger" />
                  <span class="text-lg" :class="{'text-primary': pembelianFilter == 'lunas-belum'}">Belum</span>
              </router-link>
              <router-link tag="span" class="pembelian__label flex items-center mt-6 cursor-pointer" :to="`${baseUrl}/status-lunas/lunas-sudah`">
                  <div class="h-3 w-3 rounded-full mr-2 bg-success" />
                  <span class="text-lg" :class="{'text-primary': pembelianFilter == 'lunas-sudah'}">Lunas</span>
              </router-link>
          </div>
        </div>

        <vs-divider></vs-divider>

        <div class="px-6 py-4">
          <div class="flex items-center flex-wrap justify-between">
              <div class="flex items-center">
                <h5>Tag</h5>
              </div>
              <div class="flex">
                  <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="activePromptTags = true" />
              </div>
          </div>
          <div class="pembelian__lables-list">
              <router-link tag="span" class="pembelian__label flex items-center mt-6 cursor-pointer" v-for="(tag, index) in pembelianTags" :key="index" :to="`${baseUrl}/${taxonomy}/${tag.slug}`">
                  <div class="ml-1 h-3 w-3 rounded-full mr-4" :class="'border-2 border-solid border-' + tag.color" />
                  <span class="text-lg" :class="{'text-primary': pembelianFilter == tag.slug}">{{ tag.name }}</span>
              </router-link>
          </div>
        </div>
        <vs-prompt
        title="Add Tag"
        accept-text= "Submit"
        button-cancel = "border"
        @cancel="clearTag"
        @accept="submitTag"
        @close="clearTag"
        :is-valid="validateTag"
        :active.sync="activePromptTags">
          <div>
            <form>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <vs-input name="title" class="w-full mb-4 mt-5" placeholder="Title" v-model="dataTag" />
                  <vs-select
                    class="w-full"
                    label="Color"
                    v-model="dataColor"
                    >
                      <vs-select-item value="pilih" text="Pilih"/>
                      <vs-select-item :key="index" :value="item" :text="item" v-for="(item, index) in dataColorx"/>
                  </vs-select>
                </div>
              </div>

            </form>
          </div>
        </vs-prompt>

        <vs-divider></vs-divider>
        
        <div class="px-6 py-4">
          <h5>Range Tranksaksi</h5>
          <div class="pl-4 mt-6">
            <vue-range-slider 
              v-model="rangeTotal" 
              :min="minRange" :max="maxRange" 
              :tooltip-merge="tooltipMerge"
              :enable-cross="enableCross"
              tooltip-dir="left">
            </vue-range-slider>
          </div>
          <vs-button color="#3498db" type="border" icon-pack="feather" icon="icon-arrow-right" size="" class="w-full mt-4" @click="rangeData">Submit</vs-button>
        </div>

        <vs-divider></vs-divider>

        <!-- all -->
        <div class="px-6 py-4">
          <router-link tag="span" class="flex cursor-pointer" :class="{'text-primary': pembelianFilter == 'trash'}" :to="`${baseUrl}/filter/trash`">
              <feather-icon icon="TrashIcon" :svgClasses="[{'text-primary stroke-current': pembelianFilter == 'trash'}, 'h-6 w-6']"></feather-icon>
              <span class="text-lg ml-3">Trash</span>
          </router-link>
        </div>

        

    </div>
</template>
  
<script>

import 'vue-range-component/dist/vue-range-slider.css'
import VueRangeSlider from 'vue-range-component'

export default{
  components: {
    VueRangeSlider 
  },
  props: {
    pembelianFilter: {
      type: String,
      required: true
    },
    maxRange: {
      type: Number,
      required: true
    },
    dateMulai: {
      type: String,
    },
    dateSampai: {
      type: String,
    },
    Search: {
      type: String,
    }
  },
  data () {
    return {
      minRange: 0,
      rangeTotal: [0,this.maxRange],
      enableCross: false,
      tooltipMerge: false,
      formatter: value => `￥${value}`,

      activePromptTags: false,
      dataTag: null,
      dataColor: 'pilih',
      dataColorx: ['primary', 'success', 'danger', 'warning', 'dark']
    }
  },
  computed: {
    validateTag () {
      return !this.errors.any() && this.dataTag && this.dataColor != 'pilih'
    },
    pembelianTags () {
      return this.$store.state.pembelian.tranksaksiTags
    },
    pembelianKategoris () {
      return this.$store.state.pembelian.tranksaksiKategoris
    },
    validateSupplier () {
      return !this.errors.any() && this.dataSupplier && this.dataColor != 'pilih'
    },
    suppliers () {
      return this.$store.state.supplier.kontaks
    },
    taxonomy () {
      return 'tag-pembelian'
    },
    /*
    pembelianFilter () {
      return this.$route.params.filter
    },
    */
    baseUrl () {
      const path = this.$route.path
      const paths = path.slice(0, path.lastIndexOf('/'))
      return paths.slice(0, paths.lastIndexOf('/'))
    }
  },
  methods: {
    clearTag () {
      this.dataTag = null
      this.dataColor = 'pilih'
    },
    submitTag () {
      this.$vs.loading()
      const obj = {
        name: this.dataTag,
        term_group: 0,
        parent: 0,

        meta : {
          color: this.dataColor
        },

        taxonomy: 'tag-pembelian'
      }

      this.$store.dispatch('pembelian/addTag', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Berhasil',
          color  : 'success',
          text  : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      this.clearTag()
      this.activePromptTags = false
    },
    kategoriAddOpen() {
      this.$emit('openKategoriAdd')
    },
    supplierAddOpen() {
      this.$emit('openSupplierAdd')
    },
    supplierEditOpen(data) {
      this.$emit('openSupplierEdit', data)
    },
    rangeData () {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: '#pembelian-load',
        type: 'sound',
        scale: 0.5
      })
      this.$store.commit('pembelian/UPDATE_KAS_FILTER', this.$route.params.filter)
      let obj = {
        sub_type: 'pembelian',
        filter_type: this.$route.params.filter_type,
        filter: this.$route.params.filter,
        search: this.Search,
        range: this.rangeTotal,
        dateMulai: this.dateMulai,
        dateSampai: this.dateSampai
      }
      this.$store.commit('pembelian/SET_NULL_TASKS')
      this.$store.commit('pembelian/SET_RANGE', this.rangeTotal)
      this.$store.dispatch('pembelian/fetchTranksaksi', obj)
      if (this.$store.state.pembelian.tranksaksis.length > 0 || this.$store.state.pembelian.tranksaksis.length === 0) {
        setTimeout(() => {
          this.$vs.loading.close('#pembelian-load > .con-vs-loading')
        }, 2000)
      }
    }
  },
  created () {
    VueRangeSlider.methods.handleKeyup = ()=> console.log;
    VueRangeSlider.methods.handleKeydown = ()=> console.log;
  }
}
</script>
